import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash.get';
import cx from 'classnames';
import FaMicrophone from 'react-icons/lib/fa/microphone';
import FaMicrophoneSlash from 'react-icons/lib/fa/microphone-slash';
import TiMicrophoneOutline from 'react-icons/lib/ti/microphone-outline';
import { COPY_STRINGS } from '../../constants/translatedCopy';

class ListeningStatus extends React.Component {
  render() {
    const { isListening } = this.props;

    const animationClasses = cx({
      'animation': true,
      'active': isListening,
      'inactive': !isListening,
    });
    const iconClasses = cx({
      'listeningStatusIcon': true,
      'activeIcon': isListening,
      'inactiveIcon': !isListening,
    });

    return (
      <div className="listeningStatusContainer">
        <div className="listeningStatus">
          <div className={animationClasses}></div>
            {
              isListening ? <FaMicrophone size="45" className={iconClasses}/>
                : <FaMicrophoneSlash size="45" className={iconClasses}/>
            }
        </div>
        <span className="listeningStatusLabel labelFontOverride">
          { isListening ? COPY_STRINGS.intervention_strings.your_turn : COPY_STRINGS.intervention_strings.wait }
        </span>
      </div>
    );
  }
}

ListeningStatus.propTypes = {
  isListening: PropTypes.bool,
};

const mapStateToProps = state => {
  return {
    isListening: get(state, 'speech.listener.isListening', null),
  }
};

export default connect(mapStateToProps)(ListeningStatus);

